// src/api/automations.js
import apiClient from './client';

export const getAutomations = async () => {
  const response = await apiClient.get('/automations');
  return response.data;
};

export const getAutomation = async (id) => {
  const response = await apiClient.get(`/automations/${id}`);
  return response.data;
};

export const createAutomation = async (automationData) => {
  const response = await apiClient.post('/automations', automationData);
  return response.data;
};

export const updateAutomation = async (id, automationData) => {
  const response = await apiClient.put(`/automations/${id}`, automationData);
  return response.data;
};

export const deleteAutomation = async (id) => {
  const response = await apiClient.delete(`/automations/${id}`);
  return response.data;
};

export const toggleAutomation = async (id, active) => {
  const response = await apiClient.patch(`/automations/${id}/toggle`, { active });
  return response.data;
};

export const cloneAutomation = async (id) => {
  const response = await apiClient.post(`/automations/${id}/clone`);
  return response.data;
};

export const getAutomationStats = async (id) => {
  const response = await apiClient.get(`/automations/${id}/stats`);
  return response.data;
};

export const getAutomationPerformance = async (id) => {
  const response = await apiClient.get(`/automations/${id}/performance`);
  return response.data;
};